module.exports = __webpack_public_path__ + "img/bronze.1577a623.svg";